import React from 'react'
import { Link, Redirect } from 'react-router-dom'

import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import GridContainer from "components/grid/GridContainer.js";
import GridItem from "components/grid/GridItem.js";
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import IconButton from '@material-ui/core/IconButton';
import PrintIcon from '@material-ui/icons/Print';
import { setAllLocationRowsSelected, setLocationRowSelected, printSelectedLocations, getLocations, updateLocationList } from 'store/actions/projectActions';
import SuperTreeview from 'react-super-treeview';

class LocationList extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      filter: '',
      locationTree: null
    }
  }

  printSelected = (ev) => {
    //this.props.printSelectedLocations();

    const projectName = this.props.selectedProject.projectName;
      const companyName = this.props.selectedProject.companyName;
      const locations = this.props.filteredLocations;
      const locationRows = this.props.locationRows;
      let locationsToPrint = new Array();
      for (var i = 0; i < locationRows.length; i++) {
        if (locationRows[i] === true) {
          let location = locations[i];
          locationsToPrint.push(location.firebaseID);
        }
      }

      
      var params = {};
      
      params.companyName=companyName;
      params.projectName=projectName;
      params.locationTapeIDs = locationsToPrint;
      params.debug = "false";
      params.asPdf = "true";
      var request = new Request('https://us-central1-multilanguage-dacbe.cloudfunctions.net/printLocationTapes', {
      
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      });
      fetch(request).then(results => {
        let data = results.json();
        
        return data;
      })
      .then(data => {
          if (data.error !== undefined) {
            window.alert(data.error);
          } else {
            var pdfUrl = data.response;
            console.log(data);
            console.log(pdfUrl)
            
            window.open(pdfUrl, '_blank');
          }
      });
  }

  handleChangeFilter = (e) => {
    /*this.changeFilter({
      [e.target.id]: e.target.value
    });*/
    this.props.updateLocationList(e.target.value);
    
  }

  handleChange = (ev, checked) => {
    this.props.setAllLocationRowsSelected(checked);
  }

  handleSingleCheckboxChange = (ev, checked) => {
    const index = ev.currentTarget.id;
    this.props.setLocationRowSelected(index, checked);
    
  };

  hasSelection() {
    if (this.props.locationRows === undefined) {
      return false;
    }
    for (var i = 0; i < this.props.locationRows.length; i++) {
      if (this.props.locationRows[i] === true) {
        return true;
      }
      
    }
    return false;
  }

  createLocationTree(locations) {
    let locationTree = [];
    for (var i = 0; i < locations.length; i++) {
      if (i === 0) {
        let locationNode = {};
        locationNode.id = 1;
        locationNode.name = locations[i];
        locationTree.push(locationNode);
      }
    }
    return locationTree;

  }

  render() {
    const { locations, filteredLocations, auth, selectedProject } = this.props;
    if (!auth.uid) return <Redirect to='/signin' /> 

    if ((locations === null || locations === undefined) && (selectedProject !== null && selectedProject !== undefined)) {
      this.props.getLocations(selectedProject.companyName, selectedProject.projectName);
      return (<div>Retrieving Locations</div>);
    }

    let locationTree = this.createLocationTree(locations);

  return (
    <div>
    <div style={{display: 'flex', flexDirection: 'row', padding: '0px', margin: '0px'}}>
    
      <FormControlLabel style={{margin: '0px', padding: '0px'}}
              
              control={
      <Checkbox key="blah" style={{margin: '0px', color: 'green', height: '40px'}}
        onChange={this.handleChange.bind(this)}
        checked={this.props.locationsSelectAll === true}
      />
      
              }/>

              <div className="input-field">
                <label htmlFor="Filter">Filter</label>
                <input type="text" id='filter' onChange={this.handleChangeFilter} />
              </div>
              
              {this.hasSelection() === true ? (
              <div style={{margin: '0px'}}>
              <IconButton style={{focusOutline: "none"}}><PrintIcon onClick={this.printSelected} style={{color: "grey", focusOutline: "none"}}/></IconButton>
              {/*<IconButton><DoneAllIcon onClick={this.statusSelected} style={{color: "grey"}}/></IconButton>
              <IconButton><ForwardIcon onClick={this.assignSelected} style={{color: "grey"}}/></IconButton>
              <IconButton><CalendarIcon onClick={this.createDeadlineForSelected} style={{color: "grey"}}/></IconButton>*/}
              </div>) 
              : 
              (<div></div>)}
              </div>
    <GridContainer>
      { filteredLocations && filteredLocations.map( (location,index) => {
        return (
          
          <GridItem xs={12} sm={12} md={4}>
          <div style={{display:"flex", flexDirection:"row"}}>
             <FormControlLabel
                        
                        control={
              <Checkbox style={{margin: '0px', color: 'green', height: '0px'}}
                
                id={index}
                onChange={this.handleSingleCheckboxChange.bind(this)}
                checked={this.props.locationRows[index]}
              />
            }
            /><div>{location.hierarchy}</div>
            </div>
          </GridItem>
           
          
        )
      })}  
    </GridContainer>
    </div>
  )
    }
}

const mapDispatchToProps = dispatch => {
    return {
      
          setAllLocationRowsSelected: (checked) => dispatch(setAllLocationRowsSelected(checked)),
          setLocationRowSelected: (index, checked) => dispatch(setLocationRowSelected(index, checked)),
          getLocations: (companyName, projectName) => dispatch(getLocations(companyName, projectName)),
          printSelectedLocations: () => dispatch(printSelectedLocations()),
          updateLocationList: (filter) => dispatch(updateLocationList(filter))
    }
  }
  
  
const mapStateToProps = (state) => {
    console.log(state);
    const locations = state.project.locations;
    return {
      auth: state.firebase.auth,
      locations: locations,
      filteredLocations: state.project.filteredLocations,
      locationRows: state.project.locationRows,
      selectedProject: state.project.selectedProject,
      locationsSelectAll: state.project.locationsSelectAll
    }
  }
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect([
      'tapes'
    ])
  )(LocationList)




// WEBPACK FOOTER //
// ./src/components/locations/LocationList.js